import { css } from '@emotion/core';
import { mediaRangeQueries, breakpoints } from '../theme';
import { intersection } from './index';

const sizes = {
    1: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};

const positions = {
    fill: `
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	`,
    center: `
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	`,
    left: `
		top: 50%;
		left: 0;
		transform: translateY(-50%);
	`,
    right: `
		top: 50%;
		right: 0;
		transform: translateY(-50%);
	`,
    top: `
		top: 0;
		left: 50%;
		transform: translateX(-50%);
	`,
    bottom: `
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	`,
    'top-left': `
		top: 0;
		left: 0;
	`,
    'bottom-left': `
		bottom: 0;
		left: 0;
	`,
    'top-right': `
		top: 0;
		right: 0;
	`,
    'bottom-right': `
		bottom: 0;
		right: 0;
	`,
    'center-x': `
		left: 50%;
		transform: translateX(-50%);
	`,
    'center-y': `
		top: 50%;
		transform: translateY(-50%);
	`
};

const filled = `
    display: flex;
    flex-grow: 1;
    height: 100%;
    max-width: none;
    width: 100%;
`;

const isBrowser = typeof window !== 'undefined' && window;

const size = (props: any): any => {
    const size = props.size || '1';
    const data = props.theme.text[size];
    const width = sizes[size] || props.theme.global.size[size];

    if (size === 'filled') {
        return filled;
    }

    return css`
        width: ${width};
        max-width: ${width};
        overflow: hidden;
    `;
};

const anchor = (props: any): any => props.anchor && positions[props.anchor || 'fill'];

const hidden = (size: string) => (props: any): any => (props[size] ? {
    [mediaRangeQueries[size]]: {
        display: 'none'
    }
} : null);

const checkMatches = (): any[] => Object.keys(mediaRangeQueries).filter((key) => {
    if (isBrowser) {
        return window.matchMedia(mediaRangeQueries[key].replace('@media ', '')).matches;
    }
    return true;
});

const matchesMediaQuery = (size: string | string[]): boolean => {
    const matches = checkMatches();
    const castSizes = Array.isArray(size) ? size : [size];
    return intersection(matches, castSizes).length > 0;
};

const responsiveValue = (values: any = {}): any => {
    // if (Array.isArray(values) === false) {
    //     return values;
    // }

    // let result: any = values.length > 0 ? values[0] : null;
    // values.forEach((value, index) => {
    //     const bp = breakpoints[index];
    //     if (bp && window.matchMedia(`(max-width: ${bp})`).matches) {
    //         result = value;
    //     }
    // });
    const breapoints = Object.keys(values) || [];
    let result: any = breapoints.length > 0 ? values[breapoints[0]] : null;

    breapoints.forEach((breakpoint) => {
        if (matchesMediaQuery(breakpoint)) {
            result = values[breakpoint];
        }
    });

    return result;
};

const getPosition = (anchor: string): any => {
    switch (anchor) {
    case 'fill':
        return {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        };
    case 'fill-x':
        return {
            left: 0,
            right: 0
        };
    case 'fill-y':
        return {
            top: 0,
            bottom: 0
        };
    case 'center':
        return {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };
    case 'left':
        return {
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)'
        };
    case 'right':
        return {
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)'
        };
    case 'top':
        return {
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)'
        };
    case 'bottom':
        return {
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)'
        };
    case 'top-left':
        return {
            top: 0,
            left: 0
        };
    case 'top-right':
        return {
            top: 0,
            right: 0
        };
    case 'bottom-left':
        return {
            bottom: 0,
            left: 0
        };
    case 'bottom-right':
        return {
            bottom: 0,
            right: 0
        };
    case 'center-x':
        return {
            left: '50%',
            transform: 'translateX(-50%)'
        };
    case 'center-y':
        return {
            top: '50%',
            transform: 'translateY(-50%)'
        };
    default:
    }

    return {};
};

const scrollBarWidth = (): number => {
    const div = document.createElement('div');
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    div.style.top = '-9999px';
    div.style.width = '100px';
    document.body.appendChild(div);
    const width = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);

    return width;
};

export {
    size,
    anchor,
    hidden,
    filled,
    checkMatches,
    matchesMediaQuery,
    responsiveValue,
    getPosition,
    scrollBarWidth
};
